import { render, staticRenderFns } from "./ShippingSettingsForm.vue?vue&type=template&id=b616c396&scoped=true&"
import script from "./ShippingSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ShippingSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSettingsForm.vue?vue&type=style&index=0&id=b616c396&scoped=true&lang=css&"
import style1 from "./ShippingSettingsForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b616c396",
  null
  
)

export default component.exports